import { render, staticRenderFns } from "./moveInfo.vue?vue&type=template&id=4334b1fd&scoped=true&"
import script from "./moveInfo.vue?vue&type=script&lang=js&"
export * from "./moveInfo.vue?vue&type=script&lang=js&"
import style0 from "./moveInfo.vue?vue&type=style&index=0&id=4334b1fd&prod&lang=scss&"
import style1 from "./moveInfo.vue?vue&type=style&index=1&id=4334b1fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4334b1fd",
  null
  
)

export default component.exports